import { OTHER_LABEL } from '../checkboxgroup/EhsFormioCheckboxGroupUtil';

export type EhsFormioRadioConstructor = {
  classNames: string;
  classNamesLabel: string;
  classNamesRadios: string;
  radioOptions: Array<RadioOption>;
};
/**
 * @param classNames a string separated by spaces that will be added as classNames
 * @param radioOptions the options the user will be able to select
 */
export type EhsFormioRadioSettings = {
  classNames?: string;
  classNamesLabel?: string;
  classNamesRadios?: string;
  radioOptions: Array<RadioOption>;
  defaultValue?: string | RadioOption;
};

export type RadioOption = {
  radioLabel: string;
  radioValue: string;
  default: boolean;
};

export function buildDefaultRadioOptionFromString(
  labelOrValue: string,
  radioOptions: RadioOption[]
): RadioOption {
  const matchingItem = radioOptions.find(
    option => option.radioValue === labelOrValue
  );

  const otherItem = radioOptions.find(
    option => option.radioValue === OTHER_LABEL
  );

  if (!matchingItem && otherItem) {
    otherItem.radioLabel = labelOrValue;
    otherItem.default = true;
    return otherItem;
  }

  return {
    radioLabel: labelOrValue,
    radioValue: labelOrValue,
    default: true
  };
}

/**
 * Tries to retrieve a valid default value.
 *
 * @param defaultValue defaultValue passed by formio
 * @param radioOptions the options the user will be able to select
 */
export function getOrBuildDefaultRadioOption(
  radioOptions: RadioOption[],
  defaultValue?: RadioOption | string
): RadioOption | null {
  if (isRadioValueString(defaultValue)) {
    return buildDefaultRadioOptionFromString(defaultValue, radioOptions);
  }

  if (isRadioValueRadioOption(defaultValue)) {
    return defaultValue;
  }

  return radioOptions.find(option => option.default) ?? null;
}

export function isRadioValueString(
  value?: string | RadioOption
): value is string {
  return typeof value === 'string';
}

export function isRadioValueRadioOption(
  value?: string | RadioOption
): value is RadioOption {
  return typeof value === 'object' && 'radioValue' in value;
}
